'use strict';
import { module } from '../app';

// Matches the option-list <ul> that ng-dropdown-multiselect renders in place. Ionic's JS scroll
// engine (ion-scroll with overflow-scroll="false") calls preventDefault() on every touchstart inside
// its container, which kills the list's native overflow scrolling on touch devices. data-tap-disabled
// opts the subtree out of both Ionic's scroller and its tap system, so the list scrolls natively and
// option clicks fall through to ng-click as native clicks.
const TAP_DISABLED_ATTRIBUTE = 'data-tap-disabled';
const TAP_DISABLED_VALUE = 'true';

module.directive('dropdownMenuForm', [
  function () {
    return {
      restrict: 'C',
      link: function (scope, element) {
        element.attr(TAP_DISABLED_ATTRIBUTE, TAP_DISABLED_VALUE);
      }
    };
  }
]);



// WEBPACK FOOTER //
// ./src/scripts/directives/dropdownMenuForm.js